import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button } from '../../ui/Button';
import styles from './SiteNav.module.css';

const navItems = [
  { label: 'Platform', to: '/platform' },
  { label: 'Solutions', to: '/solutions' },
  { label: 'Why NAATS', to: '/why-naats' },
  { label: 'Contact', to: '/contact' },
];

export function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={[styles.nav, scrolled ? styles.scrolled : styles.transparent].filter(Boolean).join(' ')}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo} aria-label="NAATS Home">
          <img src="/img/naats.png" alt="NAATS Group Inc." className={styles.logoImg} />
        </Link>

        <nav aria-label="Primary navigation">
          <ul className={styles.links}>
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    [styles.navItem, isActive ? styles.navItemActive : '']
                      .filter(Boolean)
                      .join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.actions}>
          <Button to="/contact" variant="primary" size="sm">
            Request a Demo
          </Button>
        </div>

        <button
          className={styles.mobileToggle}
          onClick={() => setMobileOpen((o) => !o)}
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
        >
          {mobileOpen ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M3 6h14M3 10h14M3 14h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </div>

      <div
        className={[styles.mobileMenu, mobileOpen ? styles.mobileOpen : ''].filter(Boolean).join(' ')}
        aria-hidden={!mobileOpen}
      >
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={styles.mobileLink}
            onClick={() => setMobileOpen(false)}
          >
            {item.label}
          </NavLink>
        ))}
        <div className={styles.mobileCta}>
          <Button to="/contact" variant="primary" fullWidth onClick={() => setMobileOpen(false)}>
            Request a Demo
          </Button>
        </div>
      </div>
    </header>
  );
}
